import { UntypedFormGroup } from "@angular/forms";

/**
 * Evaluatoor function
 */
export type PolluxFormDisabledEvaluatorFn = (form: UntypedFormGroup, formReadOnly: boolean) => boolean;

/**
 * Evaluator definitions
 */
export class PolluxFormDisabledEvaluator {
  /**
   * Disables the field if formReadOnly is true
   * @returns true or false
   */
  public static formReadOnly(): PolluxFormDisabledEvaluatorFn {
    return (_form: UntypedFormGroup, formReadOnly: boolean) => {
      return formReadOnly;
    };
  }

  /**
     * Disables the field if the field value is truthy
     * @returns true or false
     */
  public static fieldIsSet(fieldName: string, targetValue: any): PolluxFormDisabledEvaluatorFn {
    return (form: UntypedFormGroup, _formReadOnly: boolean) => {
      if (!form) {
        return false;
      }
      const field = form.get(fieldName);
      if (field && field.value === targetValue) {
        return true;
      }
      return false;
    }
  }

  /**
   * Disables the field if form is in edit mode
   * @returns true or false
   */
  public static isEditMode(): PolluxFormDisabledEvaluatorFn {
    return (form: UntypedFormGroup, _formReadOnly: boolean) => {
      if (!form) {
        return false;
      }
      const field = form.get('Oid');
      if (field && field.value > 0) {
        return true;
      }
      return false;
    }
  }

  /**
   * Disables the field if the field value is  not truthy
   * @returns true or false
   */
  public static fieldIsNotSet(fieldName: string, targetValue: any): PolluxFormDisabledEvaluatorFn {
    return (form: UntypedFormGroup, _formReadOnly: boolean) => {
      if (!form) {
        return false;
      }
      const field = form.get(fieldName);
      if (field && field.value !== targetValue) {
        return true;
      }
      return false;
    }
  }
}
